import React from 'react';
import SMConst from 'lib/SMConst';
import SMDropDownButton from 'components/dashboard/form/SMDropDownButton';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMORoomListTableRow extends React.Component {

  subMenuItemDidSelectRowAtIndex(rowIndex){
    const index = this.props.room.can_display ? rowIndex : rowIndex + 1;
    const room = this.props.room;
    switch (index) {
      case 0:
        if (
          room.status !== SMConst.Visibility.Visible ||
          window.confirm(I18n.t("dashboard.notice_000011"))
        ) {
          const v = SMConst.Visibility;
          const status = (this.props.room.status == v.Visible) ? v.Hidden : v.Visible;
          const formData = new FormData();
          const queries = {
            owner_id: this.props.owner.username,
            space_id: this.props.space.username,
          };
          formData.append("status", status);
          SMOwnerResource.updateRoom(this.props.owner, this.props.room.uid, formData, queries, (newRoom)=>{
            if(this.props.delegate && typeof this.props.delegate.roomDidUpdate === 'function'){
              this.props.delegate.roomDidUpdate(this.props.rowIndex, newRoom);
            }
            this.setState({room: newRoom});
          });
        }
        break;
      // case 1:
      //   if(window.confirm(I18n.t("dashboard.notice_000003"))){
	    //   }
      //   break;
      case 1:
        if(window.confirm(I18n.t("dashboard.notice_000003"))){
          const queries = {
            owner_id: this.props.owner.username,
            space_id: this.props.space.username,
          };
          SMOwnerResource.deleteRoom(this.props.owner, this.props.room.uid, queries, (data)=>{
            if(this.props.delegate && typeof this.props.delegate.roomDidDelete === 'function'){
              this.props.delegate.roomDidDelete(this.props.rowIndex);
            }
          });
	      }
        break;
    }
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  menuButtonDidSelect(e){
    this.trackPageEvent('od edit room');
  }

  render() {
    const owner = this.props.owner;
    const space = this.props.space;
    const room = this.props.room;
    let imageOverlay = "";
    const style = {
      backgroundImage: (room.attachments.length > 0) ? 'url(' + room.attachments[0].image + ')' : ''
    };

    let message = "";
    if (space.status == SMConst.Visibility.Hidden && room.status == SMConst.Visibility.Visible) {
      message = <span className="message-important">{I18n.t("dashboard.text_000017")}</span>;
    }
    if (owner.status == SMConst.OwnerStatus.Requested) {
      message = <span className="message-important">{I18n.t("dashboard.text_000016")}</span>;
    }
    let subMenuItems = [];
    if (room.can_display) {
      subMenuItems.push({title: (room.status == SMConst.Visibility.Visible) ? I18n.t("dashboard.label_000079") : I18n.t("dashboard.label_000080"), link: "#"});
    }
    //subMenuItems.push({title: "コピーして新規作成", link: "#"});
    subMenuItems.push({title: I18n.t("dashboard.label_000081"), link: "#"});

    if (!space.can_display) {
      imageOverlay = <p className="room-list__status">{I18n.t("dashboard.label_000118")}</p>;
    }
    else if (space.owner.status == SMConst.OwnerStatus.Banned || room.status == SMConst.Visibility.Hidden) {
      imageOverlay = <p className="room-list__status">{I18n.t("dashboard.label_000078")}</p>;
    }

    return (
      <div className="room-list__box clearfix">
        {imageOverlay}
        <p className="space-list__img ml20" style={style}>{space.name}</p>
        <div className="room-list__buttonarea">
          <a onClick={this.trackPageEvent.bind(this, 'od dashboard')} href={Routes.owner_dashboard_calendars_path(owner.username, {space_id: space.username, room_id: room.uid})} className="button-gray room-list__buttonarea-button w145 mt10 mb10">{I18n.t("dashboard.label_000155")}</a>
          <SMDropDownButton
            title={I18n.t("dashboard.label_000094")}
            link={Routes.edit_owner_dashboard_space_room_path(owner.username, space.username, room.uid)}
            subMenuItems={subMenuItems}
            delegate={this} />
        </div>
        <h3 className="room-list__title">{SMFormatHelper.roomName(room)}</h3>
        <p className="room-list__link">
          <a href={Routes.space_room_path(space.username, room.uid)} target="_blank" className="link-hover-border mr20">{I18n.t("dashboard.label_000083")}</a>
          {message}
        </p>
      </div>
    );
  }
}

export default SMORoomListTableRow;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/SMORoomListTableRow.jsx